module.exports = __webpack_public_path__ + "img/11825387_L.79a2fd8e.png";